/* EXECUTIVE DASHBOARD  */

import { Component, OnInit, AfterViewInit, Input  } from '@angular/core';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler,
  CountryCityService,
  UserInfoService
} from 'app'
//import { default as COLORS } from  '../../../BaseFramework/configs/color-schemes.json';
import COLORS from  '../../../BaseFramework/configs/color-schemes.json';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-medical-risk',
  templateUrl: './medical-risk.component.html',
  styleUrls: ['./medical-risk.component.scss']
})

export class MedicalRiskComponent implements OnInit, AfterViewInit {

  constructor(
    private commonUtilty: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    private userInfoService: UserInfoService,
    private apiRequestService: ApiRequestService) { }

  clientDoList  
  private _IO = null;
  //public policyIO = null;
  //public primaryInsured = {};
  currentDO;
  labReportRequirements = [];
  showRiskSection : boolean = false
  @Input() transactionState: string;
  @Input() RequirementEntityGuid: string;
  @Input() showLabReportSummary = false;
    @Input()
    set IO(value: any) {
        this._IO = value;
        this.clientDoList=this.getClientDOlistWithRole(this._IO)
        //this.getClientSpecificRequirement(this._IO);
        this.labReportRequirements = this.getLabReportsRequirements();
        //this.lifeInsured = value;
        // if (this._IO != null) {
        //     this.policyIO = this.getDOName(this._IO);
        //     console.log("policy IO in underwriting worksheet", JSON.stringify(this.policyIO));
        // }
        let listOfPrimaryInsured = this.commonUtilty.extractClientDOFromIOGeneric(value, 'PRIMARYINSURED');
      this.primaryInsured = listOfPrimaryInsured ? listOfPrimaryInsured[0] ? listOfPrimaryInsured[0] : null : null
      

    };
    primaryInsured = null

    getDOName(IO) {
        console.log(IO)
        if (IO)
            return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO'];
        else
            null
    }

    get IO() {
        return this._IO;
    }
    

    getClientDOlistWithRole(IO) {
      let output = []
    if (IO) {
      let PRIMARYINSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
      let INSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'INSURED');
      if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
        output.push(...PRIMARYINSUREDLIST);
      if (INSUREDLIST && Array.isArray(INSUREDLIST))
        output.push(...INSUREDLIST)
    }
    return output

    //   let output = []
    //   if(IO){
    //   let DO = this.commonUtilty.getDO(IO)
    //   let clientRoleList = this.commonUtilty.getRoleNode(IO)
    //   if (this.commonUtilty.isArrayIterable(clientRoleList) && IO.clientDOs) {
    //     clientRoleList.forEach(clientRole => {
    //       let clientObject = IO.clientDOs.find(client => client.guid == clientRole.clientRefGuid)
    //       if (clientObject) {
    //         let mergedClient = Object.assign({}, clientObject, clientRole)
    //         output.push(mergedClient)
    //       }
    //     });
    //   }
    // }
    //   return output
    }

    getClientSpecificRequirement(IO){
      if(IO && this.commonUtilty.isArrayIterable(IO.requirementDOs) && this.commonUtilty.isArrayIterable(this.clientDoList)){
        this.clientDoList.forEach(client => {
          let clientRequirement =  IO.requirementDOs.filter(req => req.clientRefGuid == client.guid);
          client['clientSpecificRequirement'] = [...this.getLabReportsRequirements_new(clientRequirement)];
        });
      }
    }

    getLabReportsRequirements_new(clientRequirement){
      let fetchedLabReports = [];
      if(this.commonUtilty.isArrayIterable(clientRequirement)){
        clientRequirement.forEach(requirement => {
          if(requirement.requirmentTypeCd == "LABTEST"){
            fetchedLabReports.push(requirement);
          }
        });
      }
      return fetchedLabReports;
    }

    getLabReportsRequirements(){
      let fetchedLabReports = [];
      if(this._IO && this.commonUtilty.isArrayIterable(this._IO.requirementDOs)){
        this._IO.requirementDOs.forEach(requirement => {
          if(requirement.requirmentTypeCd == "LABTEST"){
            fetchedLabReports.push(requirement);
          }
        });
      }
      return fetchedLabReports;
    }

    selectedReportDataAvailable:boolean = false;
    risk_score:number = 0;
    risk_score_graph:number = 0;
    framingham_risk:number = 0;
    riskStatus = '-';
    CRP; cholestrol ;HBA1C ; bloodPressure;
    updateSelectedReportData(data){
      console.log("lab test reports response check: ", data)
      if(this.commonUtilty.isArrayIterable(data)){
        if(environment['demo']){
          this.labTestResults = this.medicalRulesDataConfiguration;
        }else{
          this.labTestResults = data;
        }
        this.aggregateRiskScore();
        this.selectedReportDataAvailable = true;
        this.framingham_risk = this.commonUtilty.generateRandom(10, false);
        this.CRP = this.commonUtilty.generateRandom(10, false);
        this.cholestrol = this.userDetails ? this.userDetails.cholesterol ? this.userDetails.cholesterol : 150 : 150;
        this.HBA1C = this.userDetails ? this.userDetails.hba ? this.userDetails.hba : 5.2 : 5.1;
        this.bloodPressure = this.commonUtilty.generateRandom(120, true);
        this.dataCARDS = [
          {
            "name": "Cholesterol",
            "value": this.cholestrol + "mg/DL"
          },
          {
            "name": "HbA1C",
            "value": this.HBA1C + "mmol/L"
          }
        ];
        this.riskStatus = this.checkRiskStatus();
      }
    }

  checkRiskStatus(){
    if(this.framingham_risk < 5)
      return 'LOW'
    else if(this.framingham_risk >5 && this.framingham_risk < 7)
      return 'HIGH'
    else
      return 'VERY_HIGH'
  }
  userDetails = null

  ngOnInit() {
    //this.currentDO = this.commonUtilty.getDOName(this._IO);
    //this.setPolicyInsuredData();
    this.setAgeOfInsured();
    if(this.primaryInsured && this.primaryInsured.name){
      let details = this.dataSet.filter(item=> item.name == this.primaryInsured.name)
      this.userDetails = details && this.commonUtilty.isArrayIterable(details) ? details[0] ? details[0] : this.dataSet[0] : this.dataSet[0]
    }
    this.getLabtestResults()
    
   }

  //  setPolicyInsuredData(){
  //   if(this._IO && this._IO[this.currentDO]){
  //     if(this.commonUtilty.isArrayIterable(this._IO[this.currentDO].caseClients)){
  //       this._IO[this.currentDO].caseClients.forEach(insured => {
  //         if(insured.roleCd == "PRIMARYINSURED"){
  //           this.getClientData( insured.clientRefGuid);
  //         }
  //       });
  //     }
  //   }
  //  }
   
  //  getClientData(clientRefGuid){
  //   if(clientRefGuid && this.commonUtilty.isArrayIterable(this._IO['clientDOs'])){
  //     this._IO['clientDOs'].forEach(client => {
  //       if(client.guid == clientRefGuid){
  //         this.primaryInsured['fullName'] = client.nameWithSalutation || client.fullName_LF;
  //         this.primaryInsured['age'] = client.personDO['age'] || this.calculateAge(client.dateOfBirth)
  //       }
  //     });
  //   }
  //  }

  setAgeOfInsured(){
    if(this.commonUtilty.isArrayIterable(this.clientDoList)){
      this.clientDoList.forEach(client => {
        client.age = client.personDO['age'] || this.calculateAge(client.dateOfBirth)
        client.height = client.personDO['height'] + "cm"
        client.weight = client.personDO['weight'] + "kgs"
        client.BMI = this.calculateBMI(client.personDO['height'], client.personDO['weight'])
        client.BMIcategory = this.checkBMICategory(client.BMI);
        client.BMIColor =  this.checkBMIColor(client.BMIcategory);
      });
    }
  }

   calculateAge(DOB){
    var today = new Date();
    const [day, month, year] = DOB.split('/');
    const birthDate = new Date(+year, +month - 1, +day);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
   }
  /* UI :: IMPORTANT NOTE !!!
  * The UI widgets (those with ngx-charts) must be initialized AFTER the view has loaded
  * to prevent erratic display behaviour w.r.t rendering
  */
  ngAfterViewInit(): void {
    setTimeout(()=>{ this.widgetReady=true; },800);
  }

  widgetReady:boolean = false;

  /* Date */
  dateRange: any = null;
  onDashDataChange(e=900) {
    this.widgetReady=false;
    setTimeout(()=>{this.widgetReady=true}, e);
  }

  /* Data */
  dataSet = [
    {
      key    : '1',
      name   : 'John Doe',
      age    : 33,
      address: 'New York No. 1 Lake Park',
      main   : 'Life',
      policies: '950',
      sales  : '42,50,800',
      pulseRate: 72,
      bp: "122/80",
      cholesterol: 160,
      hba: 5.1,
      recommendation: "No High Risk findings to be reported",
      riskstatus: "LOW",
      height: "165cm",
      weight:"58kgs",
      bmi:"21.3"
    },
    {
      key    : '2',
      name   : 'Alice Smith',
      age    : 39,
      address: 'New York No. 1 Lake Park',
      main   : 'Health',
      policies: '895',
      sales  : '39,45,500',
      pulseRate: 85,
      bp: "124/77",
      cholesterol: 180,
      hba: 5.1,
      recommendation: "Positive Malignancy Report for Cancer",
      riskstatus: "LOW",
      height: "170cm",
      weight:"69kgs",
      bmi:"23.9"
    },
    {
      key    : '3',
      name   : 'Dan Miller',
      age    : 46,
      address: 'New York No. 1 Lake Park',
      main   : 'Life',
      policies: '904',
      sales  : '39,55,150',
      pulseRate: 67,
      bp: "125/85",
      cholesterol: 185,
      hba: 7.2,
      recommendation: "message",
      riskstatus: "MEDIUM",
      height: "180cm",
      weight:"66kgs",
      bmi:"20.4"
    },
    {
      key    : '4',
      name   : 'Liem Kim',
      pulseRate: 72,
      bp: "122/80",
      cholesterol: 160,
      hba: 5.1,
      bmi:"22",
      recommendation:"No High Risk findings to be reported"

    },
    {
      key    : '5',
      name   : 'Joey Red',
      age    : 32,
      address: 'New York No. 1 Lake Park',
      main   : 'Motor',
      policies: '1106',
      sales  : '29,99,450'
    },
    {
      key    : '6',
      name   : 'Rebecca Yuaves',
      age    : 32,
      address: 'New York No. 1 Lake Park',
      main   : 'Health',
      policies: '851',
      sales  : '28,50,050'
    },
  ];

  dataSetMedical = [
    {
      test    : 'HDL Cholesterol',
      result   : '55',
      unit    : 'mg/dL',
      range: '60 - 40 mg/dL'
    },
    {
      test    : 'LDL Cholesterol',
      result   : '180',
      unit    : 'mg/dL',
      range: '130 - 159 mg/dL'
    },
    {
      test    : 'Triglycerides',
      result   : '172',
      unit    : 'mg/dL',
      range: '150 - 199 mg/dL'
    },
    {
      test    : 'Non-HDL-C',
      result   : '147',
      unit    : 'mg/dL',
      range: '130 - 159 mg/dL'
    },
    {
      test    : 'HbA1C',
      result   : '6.8',
      unit    : 'mmol/L',
      range: '4.4 - 5.9 mmol/L'
    },
    {
      test    : 'CRP',
      result   : '3.4',
      unit    : 'mg/L',
      range: '0 - 3 mg/L'
    }
  ];


  /* Size */
  view: any[] | undefined = undefined;

  gradient = false;
  showLegend = false;

  showXAxis = true;
  showXAxisLabel = true;
  xAxisLabel = 'Vertical';
  showYAxis = true;
  showYAxisLabel = true;
  yAxisLabel = 'Sales';
  timeline = false;


  /* ====================================== */
  /* UI COLOR SCHEME SELECTION AND SETTING  */
  colorSchemes = COLORS;
  colorSchemesNames = COLORS.map(i=>i.name);
  colorScheme = {
    name: 'horizon',
    selectable: true,
    group: 'Continuous',
    domain: COLORS.find(i=>i.default).scheme,
  };
  colorSchemeTempModel:any = COLORS.findIndex(i=>i.default);
  colorSchemeModelChange() {
    let temp = this.colorScheme;
    temp['domain'] = this.colorSchemes[this.colorSchemeTempModel].scheme;
    this.colorScheme = Object.assign({}, temp);
    this.onDashDataChange(900); /* Reload */
  }
  /* ====================================== */


  //pie
  showLabels = true;

  single = [
    {
      "name": "New Delhi",
      "value": 2243772
    },
    {
      "name": "Mumbai",
      "value": 1126000
    },
    {
      "name": "Bangalore",
      "value": 896215
    },
    {
      "name": "Pune",
      "value": 557363
    },
    {
      "name": "Nagpur",
      "value": 196750
    },
    {
      "name": "Cochin",
      "value": 186900
    },
  ];
  multi = [
    {
      "name": "Life",
      "series": [
        {
          "name": "Policies",
          "value": 2243772
        },
        {
          "name": "Claims",
          "value": 122700
        }
      ]
    },
    {
      "name": "Health",
      "series": [
        {
          "name": "Policies",
          "value": 1126000
        },
        {
          "name": "Claims",
          "value": 76466
        }
      ]
    },
    {
      "name": "Motor",
      "series": [
        {
          "name": "Policies",
          "value": 296215
        },
        {
          "name": "Claims",
          "value": 29922
        }
      ]
    },
    {
      "name": "Travel",
      "series": [
        {
          "name": "Policies",
          "value": 257363
        },
        {
          "name": "Claims",
          "value": 56992
        }
      ]
    },
    {
      "name": "Property",
      "series": [
        {
          "name": "Policies",
          "value": 196750
        },
        {
          "name": "Claims",
          "value": 1246
        }
      ]
    },
    {
      "name": "Episodic",
      "series": [
        {
          "name": "Policies",
          "value": 204617
        },
        {
          "name": "Claims",
          "value": 14970
        }
      ]
    }
  ];
  card = [
    {
      "name": "Life",
      "value": 8940000
    },
    {
      "name": "Health",
      "value": 3000000
    },
    {
      "name": "Motor",
      "value": 4940000
    },
    {
      "name": "Travel",
      "value": 5400000
    },

  ];
  pie = [
    {
      "name": "Life",
      "value": 40632,
      "extra": {
        "code": "de"
      }
    },
    {
      "name": "Health",
      "value": 50000,
      "extra": {
        "code": "us"
      }
    },
    {
      "name": "Motor",
      "value": 36745,
      "extra": {
        "code": "fr"
      }
    },
    {
      "name": "Travel",
      "value": 36240,
      "extra": {
        "code": "uk"
      }
    },
  ];

  onSelect(e) {
    console.log('ngx-chart',e);
  }

  dataCARDS: any[] = [];


  TEST_RULES_DATA = [
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Black Listed Intermediary",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Accepted",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Loss Ratio of Sales Person",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Accepted",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Intermediary with High Claims Frequency",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Rejected",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    },
    {
      "parentObject": null,
      "versionId": 1,
      "guid": null,
      "createdDt": 1529245059190,
      "updatedDt": 1529245059190,
      "createdUser": "AdminScript",
      "updatedUser": "AdminScript",
      "baseCompanyCd": "MMS",
      "versionNum": null,
      "caseManager": null,
      "workflowStatusCd": null,
      "errorFl": false,
      "warningFl": false,
      "pendingReqFl": false,
      "exceptionDOList": null,
      "id": 20309,
      "entityGuid": "5DAD6F2C-AEDC-4CF8-B253-B84C3C8BB194",
      "ruleName": "Loss Ratio of Sales Person",
      "ruleSubType": "AUWPolicy",
      "category": null,
      "decisionType": "RATING",
      "decision": "Accepted",
      "remarks": null,
      "weight": "5",
      "decisionValue": "Accepted Standard",
      "recommendationCategory": null,
      "recommendation": null,
      "rcmdClause": null,
      "rcmdRequirement": null,
      "rcmdRatingMethod": null,
      "rcmdRatingPoints": null,
      "clientId": null,
      "clientRefGuid": null,
      "objectName": "AutoUWResultDO"
    }
  ];



  /* Carousel */
  effect = 'scrollx';
  carouselContent = [
    { title: "Q3 Report is out", content: "Profits are up 4.56% compared to Q3 2018" },
    { title: "D2C Social Media Contest planned", content: "A contest is planned in Q1 2020 to increase direct sales" },
  ];


  /* Search */
  searchTerm:string = '';

  /* Agent Search -- FAKE */
  isSearching = false;
  agentSearch() {
    this.isSearching = true;
    this.dataSet = this.Shuffle(this.dataSet); /* Fake sort */
    this.dataSet = this.dataSet.sort(() => Math.random() - 0.15 ); /* Fake sort */
    setTimeout(()=>{this.isSearching = false;},800);
  }
  Shuffle(o) {
    for(var j, x, i = o.length; i; j = parseInt(String(Math.random() * i)), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  };

  medicalSummary: string;
  fetchedMedicalReportSummary(data){
    this.medicalSummary = data;
  }

  medicalRiskView ="graphicalView";

refreshMedicalRulesFlag: boolean =true;
labTestResults : any;
updateValidatedData(data){
  console.log("check emitted data", data);
  if(environment['demo']){
    this.labTestResults = this.medicalRulesDataConfiguration;
  }else{
  this.labTestResults = data.find(e => true)['labTestResults'];
  }
  this.aggregateRiskScore();
  this.refreshMedicalRulesTable();
}

  private aggregateRiskScore() {
    let labRiskScoreArr = [];
    let aggOfRiskScore:number = 0;
    if(this.commonUtilty.isArrayIterable(this.labTestResults)){
      labRiskScoreArr = this.labTestResults.map(i => i.riskScore);
    }
    if(this.commonUtilty.isArrayIterable(labRiskScoreArr)){
      aggOfRiskScore = labRiskScoreArr.reduce(function (sum, a) {
        if (!isNaN(a)) { 
          return Number(sum) + Number(a); 
        }
      });
    }

    if(aggOfRiskScore){
      this.risk_score = Number(aggOfRiskScore) / this.labTestResults.length;
      this.risk_score = this.risk_score ? Number(this.risk_score.toFixed(2)) : this.risk_score;
      this.risk_score_graph = this.risk_score ? Number((this.risk_score * 10).toFixed(2)) : this.risk_score;
    }
  }

  //Formula: [weight (kg) / height (cm) / height (cm)] x 10,000
  calculateBMI(height, weight){
    let BMI:number = 0;
    height = Number(height);
    weight = Number(weight);
    if(!(isNaN(height) || isNaN(weight))){
      BMI = (weight/(height*height)) * 10000;
    }
    return BMI.toFixed(2);;
  }

  //   BMI Ranges by CDC:
//   Below 18.5 -	Underweight
// 18.5 – 24.9 -	Healthy Weight
// 25.0 – 29.9 -	Overweight
// 30.0 and Above	- Obesity
  checkBMICategory(BMI){
    if(BMI){
      if(BMI < 18.5){
        return "Underweight";
      }else if(BMI >= 18.5 && BMI <= 24.9){
        return "Normal";
      }else if(BMI >= 25 && BMI <= 29.9){
        return "Overweight"
      }else{
        return "Obesity"
      }
    }else
      return "-";
  }

  checkBMIColor(BMIcategory){
    if(BMIcategory){
      if(BMIcategory == "Underweight"){
        return "warning";
      }else if(BMIcategory == "Normal"){
        return "success";
      }else if(BMIcategory == "Overweight"){
        return "warning"
      }else{
        return "danger"
      }
    }else
      return "default";
  }

refreshMedicalRulesTable(){
  this.refreshMedicalRulesFlag = false;
  setTimeout(()=>{ this.refreshMedicalRulesFlag = true },300);
}

medicalRulesDataConfiguration = [
  {
    testCd: "Haemoglobin",
    result: "Additional Requirement",
    riskRating: "High",
    riskScore: "5",
    reason: "Haemoglobin below normal range",
    recommendation: "Additional reports required due to very low haemoglobin, High Risk of anaemia"
  },
  {
    testCd: "Lipid Profile",
    result: "Standard",
    riskRating: "Low",
    riskScore: "5",
    reason: "Normal",
    recommendation: null
  },
  {
    testCd: "Serum Albumin",
    result: "Standard",
    riskRating: "Low",
    riskScore: "2",
    reason: "The serum albumin level is at the borderline level",
    recommendation: "The serum albumin level is at the lower limit of the normal range"
  },
  {
    testCd: "White blood cells (WBC)	",
    result: "Standard",
    riskRating: "Low",
    riskScore: "0",
    reason: "WBC count is normal",
    recommendation: null
  },
  {
    testCd: "BMI",
    result: "Standard",
    riskRating: "Medium",
    riskScore: "3",
    reason: "BMI is above normal range, overweight",
    recommendation: null
  }
]


labreportParameterData = []
// CHOLESTEROL, HBA1C , RECOMMENDATION, PULSE RATE
labReportParameters = [
  {"type" : "PULSE RATE"},
  {"type" : "CHOLESTEROL"},
  {"type" : "BLOOD PRESSURE"},
  {"type" : "HBA1C"},
  {"type" : "RECOMMENDATION"},
]

healthParams = {
  "HEIGHT" : null,
  "WEIGHT" : null,
  "BMI" : null
}
  getLabtestResults() {
    let url = 'documentFetchByEntityGuid'
    let pathVariables = [];
    pathVariables.push(this.RequirementEntityGuid);
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(documents => {
      if (documents && this.commonUtilty.isArrayIterable(documents) && documents.length) {
        let labTestDocument = documents.filter(doc => doc.documentTypeCd == "LABTEST")
        let labTestGuid = null
        if (labTestDocument && this.commonUtilty.isArrayIterable(labTestDocument) && labTestDocument.length)
          labTestGuid = labTestDocument[0].guid;

        if (labTestGuid) {
          let body = {
            "documentGuid": labTestGuid,
            "labTestDOs": []
          }
          console.log("check payload body before save lab test: ", body)

          let url = 'labtestSave'
          this.apiRequestService.postCallWithAPIMapper(url,body).subscribe(data => {
            if (data) {
              let url = 'labtestFetchByEntityGuid'
              let pathVariables = []
              pathVariables.push(this.RequirementEntityGuid)
              this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(data => {
                if (data && this.commonUtilty.isArrayIterable(data) && data.length) {
                  data.forEach((labData, i) => {
                    if (labData && labData['labTestResults'] && this.commonUtilty.isArrayIterable(labData['labTestResults']) && labData['labTestResults'].length) {
                      this.labreportParameterData[i] = {}
                      labData['labTestResults'].forEach(results => {
                        if (results.typeCd == 'HEALTHATTRIBUTES') {
                          this.labReportParameters.forEach(parameter => {
                            if (parameter['type'] == results['testCd']) {
                              // parameter['value'] = results['value'] ?  results['value'] : 0;
                              this.labreportParameterData[i][parameter['type']] = results['value'] ? results['value'] : results['recommendation'];
                              // this.labreportParameterData[i]['measureUnitCd'] = results['measureUnitCd'] ? results['measureUnitCd'] : null
                            }
                          })
                          if (results.testCd == 'BMI') this.healthParams.BMI = results.value
                          if (results.testCd == 'WEIGHT') this.healthParams.WEIGHT = results.value
                          if (results.testCd == 'HEIGHT') this.healthParams.HEIGHT = results.value
                        }
                      })
                    }
                  })
                  console.log("lab test parameter data = ", this.labreportParameterData);
                }

              });
            }
          });
        }

      }

    })
  }
}
